import { useState } from "react";
import { FAQSC } from "./faqs.styles";

const FAQ = [
    {
        question: "Who should seek counselling?",
        answer:
            "Anyone experiencing stress, anxiety, Depression, emotional distress, academic pressure, relationship difficulties, or " +
            "simply seeking personal growth can benefit from counselling.",
    },
    {
        question: "Is counselling confidential?",
        answer:
            "Yes. All sessions are strictly confidential and follow ethical counselling standards.",
    },
    {
        question: "How many sessions will I need?",
        answer:
            "The number of sessions depends on individual concerns. Generally, people benefit from short-term therapy (6–8 sessions), while others may prefer longer support.",
    },
    {
        question: "Do you provide student counselling?",
        answer:
            "Yes. Special focus is given to student mental health, academic stress, exam anxiety, and emotional wellbeing in higher education settings.",
    },
    {
        question: "Are online sessions effective?",
        answer:
            "Yes. Online counselling is effective for many psychological concerns.",
    },
    {
        question: "Is medication prescribed?",
        answer:
            "Niraatanka Counselling Centre provides psychological therapy. If medication is required, referral to a qualified psychiatrist will be suggested.",
    }
];


export default function FAQHolder({ ref }) {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggle = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    return <FAQSC>
        <div className="faq-title" ref={ref}>
            FREQUENTLY ASKED QUESTIONS
        </div>
        {FAQ.map((faq, index) => {
            const isOpen = index === activeIndex;

            return (
                <div
                    key={index}
                    className={`faq-item ${isOpen ? "open" : ""}`}
                >
                    <button
                        className="faq-question"
                        onClick={() => toggle(index)}
                    >
                        <span>{faq.question}</span>
                        <span className="faq-icon">
                            {isOpen ? "×" : "+"}
                        </span>
                    </button>

                    <div className="faq-answer">
                        <p>{faq.answer}</p>
                    </div>
                </div>
            );
        })}
    </FAQSC>;
}
